var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m33.12 7.462 4.063 4.828-1.53 1.288-2.333-2.772-7.824 11.938-3.879-3.88-5.152 6.441-8.633-10.87-3.715 3.713-3.24-3.24 1.414-1.414 1.826 1.826 3.886-3.886 8.467 10.662 4.981-6.226 3.72 3.72z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M10.334 4.583h5.5v1.5h-4v23.834h4v1.5h-5.5zM29.25 31.415h-5.5v-1.5h4V6.082h-4v-1.5h5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgDetails;